import React from 'react';
import { useDispatch } from 'react-redux';

import { Product } from 'constants/searchTypes';
import { track } from 'apis/amethyst';
import { evRecommendationClick } from 'events/recommendations';
import { useSponsoredAds } from 'hooks/useSponsoredAds';
import { trackSponsoredAdImpressions } from 'actions/products';
import SponsoredAdsCarousel from 'components/search/SponsoredAdsCarousel';

export interface OwnProps {
  stockId: string;
  keywords: string[];
  containerClassName: string;
  isFullMaxWidth?: boolean;
}

const PdpSponsoredAds = ({ stockId, keywords, containerClassName, isFullMaxWidth = false }: OwnProps): React.ReactElement => {
  const sponsoredAds = useSponsoredAds({ stockId, keywords, pageType: 'Product' });
  const dispatch = useDispatch();

  const makeTrackSponsoredAdClick = (product: Pick<Product, 'productId' | 'styleId' | 'colorId'>, index: number) => {
    const { productId, styleId, colorId } = product;
    return () => {
      track(() => [
        evRecommendationClick,
        {
          index,
          recommendationType: 'PRODUCT_RECOMMENDATION',
          productIdentifiers: {
            productId,
            styleId,
            colorId
          },
          recommendationSource: 'MICROSOFT',
          widgetType: 'MICROSOFT_TOP_BLOCK',
          sourcePage: 'PRODUCT_PAGE'
        }
      ]);
    };
  };

  return (
    <SponsoredAdsCarousel
      containerClassName={containerClassName}
      sponsoredAds={sponsoredAds}
      trackSponsoredAdImpressions={({ url }: { url: string }) => dispatch(trackSponsoredAdImpressions({ url }))}
      makeSponsoredAdClick={makeTrackSponsoredAdClick}
      isFullMaxWidth={isFullMaxWidth}
    />
  );
};

export default PdpSponsoredAds;
